module.exports = __webpack_public_path__ + "static/media/bg_middle_tab1.2579b371.png";